<template>
  <div class="block" style="margin-bottom: -6px">
    <video
      src="../assets/videos/hands.mp4"
      autoplay
      loop
      muted
      defaultMuted
      playsinline
    ></video>

    <div class="container position-absolute top-50 start-50 translate-middle">
      <h1 class="text-center header-title pb-5">Unsere Kompetenzen</h1>

      <div id="accordionFlushCompetence" class="accordion accordion-flush">
        <!-- Loop -->
        <div
          v-for="(skill, index) in skills[viewStore.selfOrCompany]"
          :key="index"
          class="accordion-item"
        >
          <h2 class="accordion-header" :id="'flush-heading' + index">
            <button
              class="accordion-button collapsed"
              data-bs-toggle="collapse"
              :data-bs-target="'#flush-collapse' + index"
              aria-expanded="false"
              :aria-controls="'flush-collapse' + index"
            >
              {{ skill.header }}
            </button>
          </h2>
          <div
            :id="'flush-collapse' + index"
            class="accordion-collapse collapse"
            :aria-labelledby="'flush-heading' + index"
            data-bs-parent="#accordionFlushCompetence"
          >
            <div class="accordion-body">
              {{ skill.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const skills = ref({
  self: [
    {
      header: "Social Content",
      description:
        "Wir verwandeln deinen Podcast in ansprechenden Social Media Content, Newsletter oder deinen Blog. Damit du gehört UND gesehen wirst.",
    },
    {
      header: "Distribution",
      description:
        "Die Veröffentlichung ist neben der Produktion eine der entscheidend-sten Komponenten im Podcasting. Wir kümmern uns um deine Veröffentlichung und sorgen mit smarten SEO-Strategien für maximale Reichweite auf allen Plattformen.",
    },
    {
      header: "Audio Branding",
      description:
        "It's a match! Wir kreieren und gestalten einzigartige Intros, kreative Jingles und maßgeschneiderte Soundelemente, die perfekt auf deine Marke abgestimmt ist und sich mit deiner Zielgruppe & Hörerschaft identifiziert.",
    },
    {
      header: "Werbung",
      description:
        "Ohne Moos nix los. Wir beraten dich bei Anfragen für Werbekooperationen, unterstützen beim Reporting und der technischen Umsetzung von Werbung im Podcast.",
    },
    {
      header: "Konzepte",
      description:
        "Wir entwickeln ganzheitliche Konzepte. Von der Themenfindung, über die Marktanalyse bis hin zur Formatgestaltung. Zusätzlich bieten wir crossmediale Beratung, damit deinem Podcast noch mehr Reichweite generiert.",
    },
    {
      header: "Management",
      description:
        "Lean back - Wir behalten den Überblick. Von der Planung, über die Veröffentlichung, bis hin zum Gäste-Management. Wir betreuen dich ganzheitlich und sorgen dafür, dass alle Prozesse nahtlos zusammen laufen.",
    },
    {
      header: "Aufnahme & Technik",
      description:
        "Die perfekte Mikrofonwahl, das beste Set-up für deine Stimme und die deiner Gäste und schnelle Lösungen bei Technikfragen. Bei uns klingst du immer richtig.",
    },
    {
      header: "Reporting & Analyse",
      description:
        "Hörer, Schneller, Weiter! In unseren persönlichen 1:1 Sessions analysieren wir deinen Erfolg. Wir tüfteln gemeinsam an Strategien, damit dein Podcast wachsen darf.",
    },
  ],
  company: [
    {
      header: "Konzeption",
      description:
        "Wir beraten für ein modernes & langfristiges Podcast Format, welches eure Inhalte zum Ausdruck bringt, eure Werte vermittelt und die Zielgruppe erreicht, die sich mit euch identifiziert.",
    },
    {
      header: "Umsetzung",
      description:
        "Wir unterstützen euch bei der technischen Umsetzung des Podcasts. Wir geben euch smarte und lösungsorientierte Tools mit an die Hand, mit denen ihr und eure Mitarbiter*in sich wohl fühlt.",
    },
    {
      header: "Aufnahme",
      description:
        "Wir beraten euch für eine perfekte Aufnahmequalität und liefern euch bestmögliche Podcastfolgen durch unsere langjährige Erfahrung in der Post-Produktion.",
    },
    {
      header: "Sound-Design",
      description:
        "Wir schaffen Atmosphäre! Durch maßgeschneiderte Musik, kreatives Sound-Design oder Inhouse produzierte Jingles. Wir liefern euch einen individuellen Sound, der euren Podcast mit eurer Zielgruppe verbindet.",
    },
    {
      header: "Monetarisierung",
      description:
        "Sponsoring, Native Adds oder Audio-Spots? Mit unserer Expertise  begleiten wir dich bei der Suche passender Werbepartner und bieten ideale Lösungen für die Monetarisierung deines Podcasts.",
    },
    {
      header: "Innovativ",
      description:
        "Moderne Podcasts sind keine Einbahnstraße! Wir zeigen euch, wie man kreative Feedback-Kanäle aufbaut und dadurch mehr Interaktivität mit eurer Zuhörerschaft erreicht.",
    },
    {
      header: "Reporting",
      description:
        "Eure Podcastzahlen immer im Blick! Kontinuierlich bereiten wir das Reporting für euren Podcast auf. Wir analysieren die wichtigsten Zahlen und geben euch konkrete Handlungsempfehlungen mit an die Hand.",
    },
    {
      header: "Content Recycling",
      description:
        "Was wertvoll ist, soll bestmöglich verwertet werden. Von Transkription bis zur Erstellung von Videoclips: Aus dem, was deine Podcastfolge an Content bietet, kreieren wir Social Media Teaser, Quotes, Videoformate für YouTube und vieles mehr.",
    },
  ],
});
</script>

<style scoped>
.accordion-button::after {
  width: 1.8rem;
  height: 1.8rem;
  margin-left: auto;
  background-image: url("../assets/svg/plus-lg.svg") !important;
  background-size: 1.8rem;
}

.accordion-button:not(.collapsed)::after {
  background-image: url("../assets/svg/plus-lg.svg") !important;
  transform: rotate(45deg) !important;
}

.accordion-button {
  font-weight: 700;
  font-size: 1.5rem;
  background-color: rgb(255, 255, 255, 0.4);
}

.accordion-item {
  background-color: rgba(255, 255, 255, 0.3);
}

.accordion-body {
  background-color: rgba(255, 255, 255, 0.6);
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  color: black;
  /* background-color: transparent; */
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
    var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-bottom: 2px solid rgb(0, 0, 0);
  border-radius: 0;
}
.header-title {
  color: #fc4667;
  font-weight: 900;
  font-size: 3.1rem;
}
.block {
  position: relative;
  /* bottom: 0; */
  /* width: 100%; */
  /* height: 100%; */
  /* height: 1600px; */
}

.card-title {
  color: black !important;
  font-weight: 700;
}

.card-title-closed {
  color: black !important;
  font-weight: 700;
}

.card-body:hover {
  cursor: pointer;
  transition-duration: 0.5;
}

.card {
  height: 100%;
  border: none;
  background-color: rgb(249, 249, 249, 0.66);
}

video {
  width: 100%;
  height: 900px;
  object-fit: cover;
}
</style>
